import { InformationAlert } from '@nebula/alert';
import Button from '@nebula/button';
import { BodyMedium400, TitleXSmall500 } from '@nebula/global-styles';
import { TextLinkBack } from '@nebula/text-link';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  @media ${({ theme }) => theme.media.tabletPortraitMax} {
    flex-direction: column;
    justify-content: center;
  }
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    flex-direction: row;
    align-items: center;
  }
`;

export const CurrentPaymentDetails = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 16px 0px;
`;

export const FreeTrialDescription = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.color.ui.grey[100]};
  font-weight: 400;
  margin-top: 6px;
  margin-bottom: 8px;
`;

export const PaymentIconContainer = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PaymentIcon = styled.img`
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
`;

export const HorizontalLine = styled.hr`
  border: 1px solid ${({ theme }) => theme.color.ui.grey[20]};
  margin: 0px;
`;

export const ExpiryText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.color.ui.grey[80]};
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 16px;
  }
`;

export const BillingDetailsSection = styled.div`
  margin-top: ${({ $noMarginTop }) => ($noMarginTop ? '0' : '1.5rem')};
  padding: 0 16px;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    padding: 0;
  }
  @media (max-width: 767px) {
    padding-top: 24px;
    border-top: 8px solid ${({ theme }) => theme.color.ui.grey[10]};
  }
`;

export const BillingDateContainer = styled.div`
  ${({ flexRow }) =>
    flexRow &&
    `
    display: flex;
    justify-content: space-between;
    align-items: center;
  `}
  padding: 16px 0px;
`;

export const BillingDateLeft = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ChangeDateButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.color.ui.blue[70]};
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0;

  &:focus-visible {
    box-shadow: ${({ theme }) => theme.focus.shadow};
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 16px;
  }
`;

export const HeadingLabel = styled.p`
  font-size: 16px;
  color: #384553;
  font-weight: 400;
  line-height: 24px;
  margin: 0;

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 18px;
    line-height: 28px;
  }
`;

export const HeadingValue = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  margin: 0;
  margin-top: 2px;

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 18px;
  }
`;

export const PaymentandBillingContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  padding-top: 16px;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    max-width: 768px;
    padding: 24px;
  }

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    max-width: 802px;
    padding: 32px 0 0 0;
  }
`;

export const Heading = styled.h1`
  font-size: 24px;
  color: ${({ theme }) => theme.color.ui.grey[100]};
  font-weight: 500;
  line-height: 36px;
  margin-top: 24px;
  margin-bottom: 24px;
  @media ${({ theme }) => theme.media.tabletPortraitMax} {
    margin-top: 16px;
    margin-bottom: 16px;
  }
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 28px;
    line-height: 40px;
  }
`;

export const Subheading = styled.h2`
  font-size: 20px;
  color: ${({ theme }) => theme.color.ui.grey[100]};
  font-weight: 500;
  line-height: 32px;
  margin: 0;
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 24px;
    line-height: 36px;
  }
`;

export const ChangePaymentMethodButton = styled(Button)`
  align-self: flex-start;
  font-size: 14px;
  width: 100%;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    width: fit-content;
    margin-top: 0.5rem;
  }
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: 16px;
  }
`;

export const BillingDetailsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const BillingDetailsLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
`;

export const PaymentTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
  margin: 0;
  margin-left: 16px;
`;

export const PaymentText = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  margin-top: ${({ card }) => (card ? '0' : '12px')};
`;

export const AlertContainer = styled.div`
  margin-top: 24px;
`;

export const ErrorAlertContainer = styled.div`
  > div > div > div {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;

export const InformationAlertContainer = styled.div`
  margin-top: 10px;
  margin-bottom: 4px;
  > div {
    width: 100%;
    ${TitleXSmall500} {
      font-size: 14px;
    }
    ${BodyMedium400} {
      font-size: 14px;
    }
    @media ${({ theme }) => theme.media.tabletPortraitMin} {
      min-width: 596px;
      max-width: fit-content;
    }
    @media ${({ theme }) => theme.media.tabletLandscapeMin} {
      padding: 16px 16px 16px 24px;
      ${TitleXSmall500} {
        font-size: 16px;
      }
      ${BodyMedium400} {
        font-size: 16px;
      }
    }
    > div {
      max-width: fit-content;
      @media ${({ theme }) => theme.media.tabletPortraitMin} {
        padding-right: 16px;
      }
    }
    > div > div {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  }
`;

export const ChangePaymentMethodContainer = styled.div`
  > button {
    margin: 0;
  }
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    margin-left: auto;
  }
  @media ${({ theme }) => theme.media.tabletPortraitMax} {
    margin-top: 6px;
    > button {
      padding: 8.5px 24px;
    }
  }
`;

export const AlertWithReducedFontSize = styled(InformationAlert)`
  .alert-title {
    font-size: 3rem;
  }

  .alert-message {
    font-size: 0.875rem;
  }
`;

export const PaymentDetailsContainer = styled.div`
  padding: 0 16px;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    padding: 0;
  }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25rem;
`;

export const BackLinkWrapper = styled(TextLinkBack)`
  &:focus {
    outline: none;
    border: none;
    box-shadow: none;
  }
`;

export const CenteredSnackbarContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
